/* eslint-disable */

const SEOPagesAtticoMansarda = {
  plural: 'Attici e mansarde',
  singular: 'Attico o mansarda',
  pluralWA: 'Gli attici e le mansarde',
  singularWA: 'L\'attico o la mansarda',
  every: 'Tutti gli attici e le mansarde',
  forurl: 'attici-mansarde',
  ugly: 'Attico/mansarda',
  seomenuitem: true,
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Ricavate da una particolare struttura del tetto, le mansarde stanno riscuotendo un grande successo sia nelle grandi città sia nei centri più piccoli, divenendo negli ultimi anni uno degli immobili più richiesti. Con gli attici - da anni sinonimo di eleganza e ricercatezza all’interno del mercato italiano – condividono la totale esposizione alla luce, dovuta alla particolare posizione all’interno delle palazzine. Ecco spiegato uno dei tanti motivi della fortuna di questi immobili, i quali, per la natura delle loro particolari strutture, si prestano a tante possibilità diverse in termini di disposizioni e arredamento. Scopri i tanti attici e mansarde in vendita su Casa.it, dove potrai venire a conoscenza delle migliori offerte delle agenzie immobiliari italiane.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Gli attici e le mansarde in affitto sono alcuni tra gli immobili di maggiore successo nel mercato italiano e non solo. Se fino a qualche tempo fa le mansarde erano spazi ricavati da sottotetti o soffitte, confinati dalle caratteristiche della loro struttura a spazi di ripiego, oggi, proprio grazie alle stesse peculiarità, sono divenuti immobili dal grande appeal, soprattutto tra le coppie più giovani. Diversamente gli attici hanno sempre goduto di grande successo per la loro eleganza e per i grandi spazi che questi, generalmente, offrono agli inquilini. Scegliere come futura abitazione un attico o una mansarda, consente di godere della modernità di questi spazi, senza necessità di vincolarsi in modo definitivo. Scopri i tanti attici e mansarde in affitto su Casa.it, dove potrai venire a conoscenza delle principali offerte delle agenzie italiane.',
    },
  },
};
const SEOPagesCasaBiTriFamiliare = {
  plural: 'Case bi e trifamiliari',
  singular: 'Casa bi o trifamiliare',
  pluralWA: 'Le case bi e trifamiliari',
  singularWA: 'La casa bi o trifamiliare',
  every: 'Tutte le case bi o trifamiliari',
  forurl: 'case-bifamiliari-trifamiliari',
  ugly: 'Casa bi/trifamiliare',
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'È arrivato il momento di trasferirti con la tua famiglia e stai cercando una casa bifamiliare o trifamiliare in vendita? Grazie a Casa.it hai la possibilità di comparare le offerte delle più affidabili agenzie immobiliari sul suolo italiano, scegliendo tra migliaia di annunci di case bifamiliari e trifamiliari in vendita per la tua città. Scegli l’immobile con il supporto dei nostri filtri, è semplice e veloce! Cerca la soluzione più adatta per te e trasferisciti subito nella casa dei tuoi sogni.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Sono sempre di più gli italiani che scelgono di vivere con la propria famiglia in una casa bifamiliare o trifamiliare in affitto. Questa scelta non è sempre riconducibile ad un solo fattore economico; la vita moderna è flessibile, così come lo sono i rapporti lavorativi o personali, i quali possono portarci a cambiare città spesso. Ecco perché molti preferiscono legarsi a contratti di locazione, tipici delle case in affitto, che, oltre a garantire una libertà maggiore all’affittuario, non prevedono sorprese sui costi relativi a tasse o manutenzione dell’immobile. Chi vive in affitto può godere quindi di una flessibilità finanziaria e di un’autonomia superiore rispetto a chi è proprietario. Su Casa.it puoi trovare le migliori offerte di case bifamiliari e trifamiliari in affitto delle agenzie immobiliari più importanti sul mercato italiano e scoprire la soluzione che più si addice alle tue esigenze. Filtra per prezzo, metri quadrati, locali o tanto altro e scegli la tua prossima casa.',
    },
  },
};
const SEOPagesCasaIndipendente = {
  plural: 'Case indipendenti',
  singular: 'Casa indipendente',
  pluralWA: 'Le case indipendenti',
  singularWA: 'La casa indipendente',
  every: 'Tutte le case indipendenti',
  forurl: 'case-indipendenti',
  ugly: 'Casa indipendente',
  seomenuitem: true,
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Quando si sceglie di acquistare una casa indipendente, si è ben consapevoli dei tanti vantaggi che un immobile del genere può offrire. È indubbio infatti che, oltre alla possibilità di godere di spazi autonomi che garantiscono una privacy maggiore, le opportunità concesse ai proprietari di queste case siano numerose. Le tante case indipendenti in vendita disponibili su Casa.it offrono grandi libertà: si passa da quelle relative ai lavori di ristrutturazione a quelle relative ai consumi, per i quali si gode di una (quasi) totale autonomia. Tutto questo senza dover rendere conto al condominio delle proprie scelte o delle proprie abitudini. Casa.it ti permette, grazie alle schede dettagliate delle case indipendenti in vendita, di mettere a confronto le proposte delle migliori agenzie sul mercato italiano, consentendoti così di indirizzarti verso l’acquisto della tua casa indipendente.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Una casa indipendente in affitto è una buona soluzione per tutti coloro i quali, consapevoli dei vantaggi che offre un immobile del genere – che non sono legati ai soli consumi o alla possibilità bontà di maggiore livello di riservatezza – hanno bisogno di una soluzione temporanea. Le case indipendenti in affitto rispondono appieno alle richieste del mercato immobiliare perché consentono di vivere in un ambiente diverso dal classico condominio, non dovendo rispondere né a condòmini né ad amministratori della propria abitazione e degli orari o dei ritmi della propria vita. Casa.it ti permette, grazie alle proposte delle case indipendenti in affitto, di mettere a confronto le offerte delle migliori agenzie del mercato immobiliare italiano, aiutandoti nella scelta migliore per la tua futura casa indipendente.',
    },
  },
};
const SEOPagesRusticoCasale = {
  plural: 'Rustici e casali',
  singular: 'Rustico o casale',
  pluralWA: 'I rustici e i casali',
  singularWA: 'Il rustico o il casale',
  every: 'Tutti i rustici e i casali',
  forurl: 'rustici-casali',
  ugly: 'Rustico/casale',
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'La bellezza del nostro Paese, si sa, non risiede soltanto nelle splendide città d’arte; l’Italia infatti è uno dei Paesi con la più elevata biodiversità nel mondo, regalandoci paesaggi mozzafiato dalle coste del mar Mediterraneo alle Alpi. Questo giustifica la continua ricerca di rustici e casali in vendita, immersi nelle bellissime campagne italiane. Chi sceglie queste tipologie di costruzioni lo fa per apprezzare a pieno la tranquillità che offre una vita lontana dalla città, lontano quindi da traffico, caos e frenesia tipica dei centri urbani. Da ristrutturare o già abitabile, su Casa.it trovi le migliori offerte per i rustici e i casali in vendita sul suolo italiano. Affina la ricerca per regione o utilizza i numerosi filtri disponibili per trovare le soluzioni ideali per te e per la tua famiglia.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Prendere una pausa dalla vita frenetica di tutti i giorni è sicuramente qualcosa a cui tanti italiani ambiscono. Per tanti questo desiderio diventa realtà grazie ai numerosi rustici e casali in affitto in Italia. Questi raccolgono la preferenza di tanti utenti, i quali scelgono la tranquillità tipica delle campagne e la possibilità di godere di un immobile immerso nella natura. Il tipico aspetto di questi immobili conquista la fantasia degli italiani che decidono di vivere nelle splendide campagne del nostro Paese. Scegliere il miglior rustico o casale in affitto è davvero facile su Casa.it e avrai la possibilità di mettere a confronto i migliori annunci per i rustici e casali in affitto offerti dalle più importanti agenzie immobiliari che operano sul suolo italiano. Con Casa.it riuscirai a coronare il tuo sogno di vivere in una casa immersa nel verde.',
    },
  },
};
const SEOPagesvillettaASchiera = {
  plural: 'Villette a schiera',
  singular: 'Villetta a schiera',
  pluralWA: 'Le villette a schiera',
  singularWA: 'La villetta a schiera',
  every: 'Tutte le villette a schiera',
  forurl: 'villette-a-schiera',
  ugly: 'Villetta a schiera',
  seomenuitem: true,
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Con il sorgere di nuovi quartieri e nuovi comprensori, senza contare tutte le strutture meno recenti, sono molte le villette a schiera in vendita. Generalmente case monofamiliari, le villette a schiera vengono spesso associate alle architetture dei Paesi nord europei. Basti pensare alle tipiche costruzioni britanniche di epoca Vittoriana che colorano, con il rosso dei loro mattoni, le strade del Regno Unito. Queste strutture, però, sebbene con aspetto diverso, popolano anche le cittadine italiane. Tante villette a schiera in vendita sono disponibili su Casa.it: si tratta di costruzioni moderne e dotate di ogni comfort, che si sviluppano su più livelli e che dispongono di un piccolo giardino dove poter prendere una pausa dalla frenetica vita moderna. Acquistare un’elegante villetta a schiera è sicuramente un ottimo investimento; lasciatevi guidare da Casa.it nella scoperta dell’immobile perfetto per la vostra famiglia.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Tipiche di quartieri eleganti e raffinati, associate dall’immaginario collettivo ai Paesi del Nord Europa, le villette a schiera in affitto sono la risposta ideale per chi cerca una sistemazione elegante e raccolta, per sé e per la sua famiglia. Caratterizzate tipicamente da costruzioni a due piani che si affacciano su un piccolo cortile o su un giardino - il quale spesso viene convertito in un orto da chi hai il pollice verde - sono la soluzione perfetta per chi desidera un angolo di verde da condividere con la propria famiglia. Le offerte presenti su Casa.it rispondono pienamente a tutte le richieste degli utenti, grazie ai filtri con cui è possibile scremare la ricerca. Da costruzioni moderne ad immobili dall’aspetto più tradizionale: scegli la tua villetta a schiera in affitto e prendi una pausa dalla vita moderna.',
    },
  },
};
const SEOPagesGaragePostiAuto = {
  plural: 'Garage e posti auto',
  singular: 'Garage o posto auto',
  pluralWA: 'I garage e i posti auto',
  singularWA: 'Il garage o il posto auto',
  every: 'Tutti i garage e i posti auto',
  forurl: 'garage-posti-auto',
  ugly: '',
  publisherHpSlug: 'garage-e-posti-auto',
  publisherHpText: 'garage o posti auto',
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Tanti sono i vantaggi del vivere in città: gli abitanti dei centri urbani saranno d’accordo però nell’identificare il problema del parcheggio come uno dei più sentiti. Questo non riguarda solo la possibilità di parcheggiare in modo più o meno semplice rincasando dal lavoro: avere un box auto a disposizione significa preservare la propria auto da eventuali danni e furti. Se stai cercando un Garage o un posto auto in vendita, su Casa.it trovi quello che fa per te. Migliaia di annunci in tutta Italia, consultabili facilmente tramite smartphone e PC, ti permettono di trovare il posto ideale per la tua macchina. In ogni scheda è possibile trovare le informazioni che fanno a caso tuo: metratura, numero di posti auto, prezzo e tanto altro. Con Casa.it trovare un Garage o posto auto non è mai stato così facile. Cosa aspetti! Trova una casa alla tua auto.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Trovare parcheggio può essere veramente difficile e dopo una giornata lavorativa può essere davvero stressante. Negli ultimi tempi, con gli italiani che preferiscono l’utilizzo dell’auto ai mezzi pubblici, ritrovarsi prima imbottigliati nel traffico e poi alla ricerca di un parcheggio sicuro è una grossa perdita di tempo. Con i prezzi dei box alle volte davvero inaccessibili, Casa.it ti da la possibilità di trovare i garage e i posti auto in affitto più adatti a te e scegliere tra quelli disponibili vicino casa tua. Con Casa.it hai la possibilità di consultare migliaia di annunci in tutta Italia, a tua disposizione alla portata di un clic. Ti basterà selezionare il luogo in cui cercare il tuo box auto e il gioco è fatto! Avrai a disposizione tutte le informazioni necessarie per affittare il posto ideale per la tua macchina in modo facile, veloce e sicuro. Cosa aspetti! Trova tanti garage e posti auto in affitto su Casa.it.',
    },
  },
};
const SEOFooterCommercialeBuyDesc = 'Investire su una propria attività può essere la soluzione vincente per dare una svolta alla propria vita professionale e garantirsi una stabilità lavorativa. Moltissimi sono i professionisti che cercano immobili per le loro attività imprenditoriali. Gli immobili commerciali in vendita sono molto richiesti per soddisfare tutte quelle esigenze tipiche delle aziende. Ad esempio uno spazio di rappresentanza dove accogliere i clienti, magari nel centro storico della città, può essere la soluzione ideale per comunicare la bontà e il prestigio della propria azienda. Allo stesso modo le attività commerciali in vendita riscuotono un grande successo tra chi vuole lanciarsi nel mondo dell’imprenditoria. Su Casa.it ci sono tanti immobili o attività commerciali in vendita per offrire alla tua impresa un punto fisico su cui puntare, sia questo dedicato ad un servizio a contatto con il pubblico, agli uffici o al magazzino della tua azienda.';
const SEOFooterCommercialeRentDesc = 'Con il mercato del lavoro sempre più elastico emergono nuove figure lavorative, le quali non possono però fare a meno di un immobile che sia funzionale alla loro professione. Gli immobili e le attività commerciali in affitto, proprio in ragione della flessibilità del mondo lavorativo, stanno diventando sempre più richiesti da piccoli e grandi imprenditori italiani, i quali preferiscono un contratto che garantisca loro una maggiore libertà finanziaria e contrattuale. Fare la scelta giusta, in questi casi, non è sempre semplice: grazie a Casa.it.it è possibile trovare i migliori annunci di immobili e attività commerciali in affitto e visionare le schede prodotto corredate di foto e di tutti i dettagli necessari.';
const SEOPagesattivitaLicenzaCommerciale = {
  plural: 'Attività e licenze commerciali',
  singular: 'Attività o licenza commerciale',
  pluralWA: 'Le attività e le licenze commerciali',
  singularWA: 'L\'attività o la licenze commerciale',
  every: 'Tutte le attività e le licenze commerciali',
  forurl: 'attivita-licenze-commerciali',
  ugly: 'Attività/licenza commerciale',
  seomenuitem: true,
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Avere un’attività è il sogno di tantissimi italiani. La possibilità di creare qualcosa di proprio e di non dover rispondere a nessuno del proprio lavoro è sicuramente una delle posizioni più ambite, soprattutto quando l’attività è proficua. Se anche tu possiedi il giusto spirito imprenditoriale, puoi scoprire su Casa.it i tanti annunci di attività e licenze commerciali in vendita, per avviare o migliorare il tuo progetto lavorativo. Che tu voglia aprire un bar, un negozio o un’attività legata alla ristorazione, grazie a Casa.it potrai scoprire tutte le migliori soluzioni proposte dalle più affidabili agenzie immobiliari italiane. Scopri subito le tante attività e licenze commerciali in vendita su Casa.it!',
    },
    affitto: {
      tag: 'h2',
      txt: 'Avviare una propria attività non è sempre semplice e spesso l’acquisto di una licenza può essere un ostacolo difficile da superare, considerando i diversi passaggi economici e burocratici da fare. Ma un’altra via è percorribile: quella che consente di rilevare le attività e le licenze commerciali con un contratto di affitto. Su Casa.it puoi trovare tantissimi annunci offerti dalle più importanti agenzie che operano sul suolo italiano. Compara prezzi, caratteristiche, posizione e tanto altro grazie ai filtri presenti sul sito. Visiona le schede e scegli le attività e le licenze commerciali in affitto che fanno più al caso tuo e fai partire il tuo progetto.',
    },
  },
};
const SEOPagesLocaleCommerciale = {
  plural: 'Negozi, locali commerciali',
  singular: 'Negozio, locale commerciale',
  pluralWA: 'I negozi e i locali commerciali',
  singularWA: 'Il negozio o il locale commerciale',
  every: 'Tutti i negozi e i locali commerciali',
  forurl: 'locali-commerciali',
  ugly: 'Negozio/locale commerciale',
  seomenuitem: true,
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Ogni imprenditore deve poter contare su uno spazio che gli consenta di essere nelle condizioni migliori per promuovere e vendere i suoi prodotti o i suoi servizi. Uno spazio di rappresentanza come un negozio, che comunichi la bontà della propria offerta e che catalizzi l’attenzione dei clienti. Acquistare questi locali può essere la scelta giusta sia se li si vuole adibire a spazio per la propria impresa, sia se li si vuole affittare a terzi. Da un lato infatti il denaro verrà allocato per un investimento positivo per la propria attività, che non dovrà sobbarcarsi spese mensili per l’affitto; dall’altro la spesa sostenuta verrà mitigata dai canoni versati dal nuovo affittuario. I locali commerciali in vendita sul suolo italiano sono davvero moltissimi e rispondono a tutte le esigenze. Scopri le soluzioni più indicate per te grazie Casa.it. Confronta gli annunci per i locali commerciali in vendita nella tua città e scegli il tuo prossimo immobile.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Con il lavoro sempre più flessibile è importante sapersi adattare e riuscire a individuare alcune soluzioni che permettano alla propria azienda di emergere. Ad esempio, scegliere la zona ideale dove posizionare il proprio negozio ha un valore altamente strategico all’interno della pianificazione. Per minimizzare il rischio di una scelta sbagliata e non legarsi ad un luogo specifico, molti preferiscono prendere in affitto un locale commerciale. Questo permette di evitare di sobbarcarsi una spesa non indifferente e di avere la possibilità di spostarsi verso zone migliori della città. Su Casa.it trovi tutti gli annunci per locali commerciali in affitto delle più importanti agenzie italiane. Affidati al nostro comparatore, screma la ricerca grazie ai filtri a tua disposizione e fai la tua scelta. Scopri subito i tantissimi locali commerciali in affitto su Casa.it.',
    },
  },
};
const SEOFooterTerreniBuyDesc = 'Su Casa.it è possibile trovare numerosi terreni in vendita: la possibilità di acquistare un terreno fa gola a molti italiani che vedono in queste operazioni un buon investimento nel medio lungo periodo. Chiaramente il valore di questi lotti è commisurato alla possibilità che questi siano edificabili: è così che ci si assicura un prodotto che può mantenere e moltiplicare il suo valore nel tempo. Inoltre, questi possono essere convertiti per utilizzi agricoli e industriali, divenendo un vero asset da valorizzare. Scopri il terreno in vendita che fa più al caso tuo su Casa.it.';
const SEOFooterTerreniRentDesc = 'Stai cercando un terreno in affitto per la tua nuova azienda o per il tuo nuovo progetto imprenditoriale? Lascia che Casa.it ti aiuti a trovare ciò che cerchi. Grazie a Casa.it potrai cercare tra migliaia di annunci presenti in tutta Italia in modo pratico e veloce. Affina la tua ricerca con i filtri, visiona le foto delle schede e confronta migliaia di terreni adibiti ad un utilizzo agricolo o industriale. Sfrutta appieno i grandi spazi offerti da questi terreni, ideali per le operazioni di carico e di scarico e che consentono la circolazione di automezzi pesanti per le operazioni di carattere industriale. Le schede dei terreni in affitto prevedono una voce approfondita con le caratteristiche dell’immobile, all’interno del quale puoi visionare in modo preciso la dimensione o la classe energetica. Scegli il terreno in affitto più adatto alle tue esigenze.';
const SEOPagesTerrenoAgricolo = {
  plural: 'Terreni agricoli',
  singular: 'Terreno agricolo',
  pluralWA: 'I terreni agricoli',
  singularWA: 'Il terreno agricolo',
  every: 'Tutti i terreni agricoli',
  forurl: 'terreni-agricoli',
  ugly: 'Terreno agricolo',
  seomenuitem: true,
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Su Casa.it sono a disposizione tantissimi terreni agricoli in vendita. Da piccoli appezzamenti di terreno, ideali per tutti gli amanti della campagna e per chi ha sempre sognato un possedimento sul quale mettere alla prova il proprio pollice verde, a tenute di diversi ettari, adatte per l’industria agroalimentare. Acquistare questi lotti è un ottimo investimento per il futuro e grazie a Casa.it non è mai stato così facile! Grazie alle schede dettagliate puoi comparare tutti gli annunci delle agenzie più importanti d’Italia. I terreni agricoli in vendita sono dislocati su tutto il territorio - da Nord a Sud - ma puoi affinare la tua ricerca grazie ai filtri a tua disposizione. Vicino alla città, a due passi dal mare o sulle verdi colline italiane: scopri subito i terreni agricoli in vendita.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Il nostro Paese è famoso nel mondo per la sua cultura culinaria; non da meno è la fama dei prodotti alimentari Made in Italy, che provengono da materie prime che il mondo intero ci invidia. Tutto questo deriva dalle particolari condizioni climatiche di cui gode il nostro Paese e che rendono i terreni agricoli appetibili per chiunque, dal cittadino privato al piccolo imprenditore fino ad arrivare alle grandi industrie di settore. Un terreno agricolo in affitto è la soluzione ideale per tutti quelli che non intendono rilevare la proprietà del lotto e preferiscono sfruttarne le possibilità per un periodo di tempo definito. Su Casa.it puoi trovare gli annunci di terreni agricoli in affitto disponibili sul suolo italiano. Grazie ai filtri potrai scegliere tra appezzamenti pianeggianti, terreni in collina; potrai affinare la ricerca per prezzo o per metratura e tanto altro ancora. Scopri subito la soluzione migliore per te.',
    },
  },
};
const SEOPagesTerrenoEdificabile = {
  plural: 'Terreni edificabili',
  singular: 'Terreno edificabile',
  pluralWA: 'I terreni edificabili',
  singularWA: 'Il terreno edificabile',
  every: 'Tutti i terreni edificabili',
  forurl: 'terreni-edificabili',
  ugly: 'Terreno edificabile',
  seomenuitem: true,
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Comprare un terreno può essere la giusta occasione per cominciare a progettare la tua nuova casa dei sogni. Servono molte informazioni per acquistare il terreno edificabile che stai cercando: metratura, posizione, prezzo e molto altro. Reperire tutte queste specifiche tra milioni di annunci in rete non è affatto facile, ma Casa.it ha quello che fa te! Grazie a Casa.it potrai cercare tra migliaia di annunci in tutta Italia e filtrare in base alle caratteristiche che soddisfano le tue esigenze. Trovare il terreno edificabile in vendita che ospiterà la tua futura casa non è mai stato così facile. Il tuo sogno è alla portata di un clic, affidati a Casa.it.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Un terreno edificabile in affitto rappresenta una valida soluzione se si vuole risparmiare e investire più risorse nella costruzione dell’immobile. Se stai cercando un terreno edificabile in affitto, Casa.it ha la soluzione ai tuoi problemi. Casa.it ti permetterà di trovare il terreno che stai cercando tra migliaia di annunci online, velocemente e con il minimo sforzo. Scopri migliaia di annunci in tutta Italia dalla comodità di casa tua attraverso smartphone e PC e trova l’annuncio ideale che ti permetterà di trovare il terreno in affitto edificabile che fa per te.',
    },
  },
};
const SEOPagesTerrenoIndustriale = {
  plural: 'Terreni industriali',
  singular: 'Terreno industriale',
  pluralWA: 'I terreni industriali',
  singularWA: 'Il terreno industriale',
  every: 'Tutti i terreni industriali',
  forurl: 'terreni-industriali',
  ugly: 'Terreno industriale',
  seomenuitem: true,
  seofooterTitle: {
    vendita: {
      tag: 'h1',
    },
    affitto: {
      tag: 'h1',
    },
  },
  seofooterDesc: {
    vendita: {
      tag: 'h2',
      txt: 'Avviare o ampliare la propria attività commerciale è sempre un grande passo. Investire su un terreno industriale può rappresentare la svolta dell’attività aziendale, ma è importante valutare tutte le informazioni che ci fornisce il mercato immobiliare italiano prima di acquistare in modo avventato. Casa.it viene incontro alle esigenze aziendali, fornendo la possibilità di comparare migliaia di annunci in tutta Italia e filtrare i risultati in base alle caratteristiche fondamentali che si stanno cercando. Con Casa.it l’acquisto di un terreno industriale sarà facile, veloce e sicuro.',
    },
    affitto: {
      tag: 'h2',
      txt: 'Investire su un terreno industriale in affitto rappresenta una valida soluzione ai giorni d’oggi. Infatti, grazie al basso rischio imprenditoriale e alla libertà contrattuale caratteristica del contratto di locazione, le aziende hanno a disposizione maggiori risorse da investire all’interno dell’attività e, quando possibile, riescono a dislocare facilmente la loro sede in posti più strategici. Grazie a Casa.it, è possibile cercare tra migliaia di terreni industriali in affitto messi a disposizione dalle migliori agenzie immobiliare del mercato italiano. Ogni annuncio offre tutte le informazioni necessarie per consentire all’acquirente una navigazione facile, veloce e sicura.',
    },
  },
};

export const SEOPagesPtypes = {
  case: {
    plural: 'Case',
    singular: 'Casa',
    pluralWA: 'Le case',
    singularWA: 'La casa',
    every: 'Tutte le case',
    forurl: 'residenziale',
    publisherHpSlug: 'case',
    publisherHpText: 'case',
  },
  residenziale: {
    plural: 'Case',
    singular: 'Casa',
    pluralWA: 'Le case',
    singularWA: 'La casa',
    every: 'Tutte le case',
    forurl: 'residenziale',
    publisherHpSlug: 'case',
    publisherHpText: 'case',
  },
  appartamento: {
    plural: 'Appartamenti',
    singular: 'Appartamento',
    pluralWA: 'Gli appartamenti',
    singularWA: 'L\'appartamento',
    every: 'Tutti gli appartamenti',
    forurl: 'appartamenti',
    ugly: 'Appartamento',
    seomenuitem: true,
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Stai cercando un appartamento in vendita? Comprare casa è senza dubbio la migliore soluzione per chi vuole guardare al futuro con ottimismo e godere della solidità che solo un immobile può offrire. Gli appartamenti in vendita su Casa.it rispondono appieno alle esigenze di tutti gli utenti, tanta è la disponibilità sul nostro portale. Grazie alle schede presenti sul sito è possibile prendere visione delle tante possibilità e scegliere l’immobile più adatto alle proprie esigenze. Comprare casa è sicuramente una delle operazioni più importanti per la vita di tutti; affidarsi a Casa.it, che ti permette di cercare tra le offerte di appartamenti in vendita delle più grandi e affidabili agenzie del territorio, è la soluzione migliore per compiere questo passo.',
      },
      affitto: {
        tag: 'h2',
        txt: 'Sempre più italiani scelgono di vivere in un appartamento in affitto, non solo per motivi legati al lavoro lontano da casa, ma anche perché è possibile godere appieno della libertà di uno spazio abitativo che non lega l’inquilino con mutui o richieste di garanzie economiche non indifferenti. Vivere in un appartamento in affitto è una scelta all’insegna della libertà e della flessibilità, che meglio si adatta al dinamismo della vita moderna. Su Casa.it puoi trovare le offerte disponibili delle migliori agenzie del nostro territorio. Gli appartamenti in affitto rispondono a tutte le esigenze, siano queste legate al budget, alle dimensioni, al numero delle camere o alla lunghezza del contratto.',
      },
    },
  },
  'attico-mansarda': {
    ...SEOPagesAtticoMansarda,
  },
  'attico+mansarda': {
    ...SEOPagesAtticoMansarda,
  },
  'casa-bi-trifamiliare': {
    ...SEOPagesCasaBiTriFamiliare,
  },
  'casa+bi+trifamiliare': {
    ...SEOPagesCasaBiTriFamiliare,
  },
  'casa-indipendente': {
    ...SEOPagesCasaIndipendente,
  },
  'casa+indipendente': {
    ...SEOPagesCasaIndipendente,
  },
  loft: {
    plural: 'Loft',
    singular: 'Loft',
    pluralWA: 'I loft',
    singularWA: 'Il loft',
    every: 'Tutti i loft',
    forurl: 'loft',
    ugly: 'Loft',
    seomenuitem: true,
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'I loft sono spazi ricavati da ex strutture manifatturiere o industriali, convertiti in abitazione e caratterizzati da grandissimi spazi che in appartamenti tradizionali sono semplicemente impensabili. Giunti al successo recentemente, come ambienti nei quali convivono praticità e design, sono emblematici della ricerca dello spazio nella città moderna. Grandi spazi che non vengono divisi, ma rimangono unici e permettono un ripensamento dei tradizionali spazi abitativi. Trovare il loft in vendita che più si adatta alle proprie esigenze non è semplice; grazie a Casa.it, però, è possibile filtrare comodamente le diverse opzioni e scegliere quello con le caratteristiche adatte. Il catalogo è sempre aggiornato e consente di individuare il loft in vendita ideale, scremando la ricerca per prezzo, metri quadrati, anno di costruzione e così via, permettendo agli utenti di confrontare le offerte delle più importanti agenzie immobiliari.',
      },
      affitto: {
        tag: 'h2',
        txt: 'Ricavati tipicamente da strutture industriali o comunque adibite ad altri scopi, i loft in affitto sono la soluzione più adatta per tutti coloro i quali amano il design e i grandi spazi, senza dover necessariamente acquistare l’immobile. Le possibilità che si possono realizzare all’interno di questi spazi unici sono pressoché infinite: dal soggiorno che confluisce alla camera da letto, alla sala da pranzo che si fonde con lo studio. Il tutto in un ambiente estremamente moderno e contrario alle regole classiche a cui sono sottoposti gli appartamenti tradizionali. Il catalogo è sempre aggiornato e consente di individuare il loft in affitto più vicino al gusto dell’utente, consentendogli di filtrare la ricerca per prezzo, per dimensioni, per anno di realizzazione e così via, permettendo così di confrontare le offerte delle più grandi agenzie immobiliari italiane.',
      },
    },
  },
  'rustico-casale': {
    ...SEOPagesRusticoCasale,
  },
  'rustico+casale': {
    ...SEOPagesRusticoCasale,
  },
  villa: {
    plural: 'Ville',
    singular: 'Villa',
    pluralWA: 'Le ville',
    singularWA: 'La villa',
    every: 'Tutte le ville',
    forurl: 'ville',
    ugly: 'Villa',
    seomenuitem: true,
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Il sogno di tanti è quello di acquistare una villa che disponga di uno spazio verde - sempre più raro nelle città italiane – e che consenta di trovare riparo dal caos urbano. Casa.it offre la risposta a queste esigenze, offrendo le migliori soluzioni disponibili: le ville in vendita dispongono di un giardino, indipendentemente dalla loro ubicazione in città o in periferia. Nell’immaginario collettivo, le ville rappresentano quelle proprietà ideali per eleganza, architetture e spazi, nelle quali ogni famiglia vorrebbe vivere. Sebbene si possa pensare che questi immobili non siano alla portata di tutti, le numerose ville in vendita su Casa.it offrono soluzioni per tutte le tasche: acquistare una villa è la migliore risposta per godere appieno, con la propria famiglia, della propria casa.',
      },
      affitto: {
        tag: 'h2',
        txt: 'Vivere in una villa è senza dubbio la scelta migliore che si possa fare, sia per quel che riguarda chi risiede in città, sia per chi vive fuori da questa. Infatti è evidente il fascino che esercita la possibilità di avere un piccolo giardino a propria disposizione, grazie al quale passare delle bellissime giornate con la propria famiglia, trascorrendo del tempo all’aria aperta per godere appieno dei tanti benefici che questa regala; è altrettanto vero che spesso lanciarsi nell’affitto di una villa può essere un’impresa non da poco. Grazie a Casa.it puoi trovare le migliori ville in affitto sul suolo italiano: scegli fra villette monofamiliari o costruzioni più grandi, tra immobili di nuova costruzione o raffinati esempi di architettura più classica.',
      },
    },
  },
  'villetta-a-schiera': {
    ...SEOPagesvillettaASchiera,
  },
  'villetta+a+schiera': {
    ...SEOPagesvillettaASchiera,
  },
  commerciale: {
    plural: 'Immobili o attività commerciali',
    singular: 'Immobile o attività commerciale',
    pluralWA: 'Gli immobili e le attività commerciali',
    singularWA: 'L\'immobile o l\'attività commerciale',
    every: 'Tutti gli immobili e le attività commerciali',
    forurl: 'commerciale',
    publisherHpSlug: 'immobili-e-attivita-commerciali',
    publisherHpText: 'imm. o attività commerciali',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: SEOFooterCommercialeBuyDesc,
      },
      affitto: {
        tag: 'h2',
        txt: SEOFooterCommercialeRentDesc,
      },
    },
  },
  albergo: {
    plural: 'Alberghi',
    singular: 'Albergo',
    pluralWA: 'Gli alberghi',
    singularWA: 'L\'albergo',
    every: 'Tutti gli alberghi',
    forurl: 'alberghi',
    ugly: 'Albergo',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Uno dei settori che non va mai in crisi nel nostro Paese, è quello turistico. Questo grazie alle infinite meraviglie italiane, siano queste di carattere artistico, siano queste legate ad una natura che, dal mare alle montagne, incanta i turisti di tutto il mondo. Possedere una struttura alberghiera diventa quindi non solo una fonte di reddito sicuro, ma anche un investimento dal sicuro rendimento. Gli alberghi in vendita su Casa.it sono moltissimi e rispondono a tutte le esigenze degli utenti. Le schede, corredate dalle immagini e dalle caratteristiche dell’immobile, consentono una veloce consultazione delle migliori strutture alberghiere in vendita, permettendoti di scoprire gli immobili ideali per le tue attività imprenditoriali.',
      },
      affitto: {
        tag: 'h2',
        txt: 'L’Italia è uno dei Paesi più visitati grazie alle sue innumerevoli bellezze naturali e alle bellissime città che tutto il mondo ci invidia. Ecco perché investire in un’attività di tipo alberghiero può essere una buona idea, considerato il fatto che il settore turistico è uno di quelli per cui il nostro Paese è famoso. Se non si è proprietari di una struttura, sono comunque molti gli alberghi in affitto sul suolo italiano. Gli immobili sono disponibili in diverse località: partendo da quelle marittime, passando per quelle di montagna per finire con quelli nelle nostre città più importanti. Con Casa.it hai la possibilità di mettere a confronto tutti gli annunci di alberghi in affitto delle più affidabili agenzie immobiliari italiane. Scegli la struttura perfetta per i tuoi progetti imprenditoriali!',
      },
    },
  },
  'attivita-licenza-commerciale': {
    ...SEOPagesattivitaLicenzaCommerciale,
  },
  'attivita+licenza+commerciale': {
    ...SEOPagesattivitaLicenzaCommerciale,
  },
  bar: {
    plural: 'Bar',
    singular: 'Bar',
    pluralWA: 'I bar',
    singularWA: 'Il bar',
    every: 'Tutti i bar',
    forurl: 'bar',
    ugly: 'Bar',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Luogo per eccellenza della quotidianità di ogni italiano, dove fermarsi a sorseggiare un buon caffè al mattino o a gustare un aperitivo dopo il lavoro, il bar è una di quelle attività che difficilmente va in crisi. Ecco perché moltissimi considerano l’acquisto di un bar come un ottimo investimento per il presente e per il futuro. Su Casa.it sono tantissimi gli annunci disponibili per i bar in vendita, in tutte le zone del Paese. Screma la tua ricerca grazie ai filtri presenti sul nostro sito e trova le migliori offerte delle agenzie immobiliari sul nostro territorio. Da desktop o da smartphone, Casa.t ti dà la possibilità di visionare tutti gli annunci di bar in vendita comodamente da casa tua.',
      },
      affitto: {
        tag: 'h2',
        txt: 'Un bar è sicuramente un’attività dal sicuro rendimento. Punto di riferimento per tanti italiani, dove consumare un buon espresso o un pasto veloce, è anche un luogo fondamentale nella dimensione sociale delle persone che lo frequentano. Certo acquistare un bar può essere una spesa importante; è per questo che molti preferiscono rilevare un bar in affitto. Tanti sono gli italiani che scelgono di tuffarsi nel mondo dell’imprenditoria proprio affittando un bar, a conferma del fatto che le attività legate alla ristorazione sono sempre molto ambite nel nostro Paese. Su Casa.it sono tantissime le offerte relative ai bar in affitto, proposte da tutte le più importanti agenzie immobiliari che operano sul suolo italiano. Filtra la ricerca secondo i parametri e scegli il bar in affitto ideale per te!',
      },
    },
  },
  capannone: {
    plural: 'Capannoni',
    singular: 'Capannone',
    pluralWA: 'I capannoni',
    singularWA: 'Il capannone',
    every: 'Tutti i capannoni',
    forurl: 'capannoni',
    ugly: 'Capannone',
    seomenuitem: true,
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Per chi fa impresa, alcune tipologie di immobili sono davvero necessarie. Se sono fondamentali spazi come quelli di rappresentanza, gli uffici operativi e così via, è indubbio come per molte attività siano di vitale importanza i capannoni. Spesso utilizzati per le operazioni di stoccaggio e per quelle relative alla dimensione manifatturiera, sono un investimento sicuro nel tempo e l’acquisto di questi consente nel lungo periodo di ammortizzare i costi. Su Casa.it è possibile scoprire i migliori annunci di capannoni in vendita sul suolo italiano per garantire alla tua impresa uno spazio adeguato a tutte le operazioni. In città, in campagna o in posizioni strategiche rispetto all’ufficio: scopri subito i capannoni in vendita perfetti per te.',
      },
      affitto: {
        tag: 'h2',
        txt: 'Alcune imprese non possono fare a meno di alcuni immobili particolari. Non per tutte è infatti possibile operare attraverso un semplice ufficio; per chi svolge attività di carattere industriale, ad esempio, un capannone è sicuramente uno spazio imprescindibile. Spesso i costi collegati all’acquisto di questi spazi possono essere difficilmente sostenibili nel breve periodo. Ecco perché moltissimi imprenditori scelgono i capannoni in affitto. Su Casa.it le soluzioni sono davvero tantissime. Confronta le offerte delle migliori agenzie immobiliari italiane e screma la ricerca utilizzando i tanti filtri disponibili, riuscirai così a trovare la soluzione migliore per la tua impresa. Scopri subito il capannone in affitto ideale!',
      },
    },
  },
  // laboratorio: {
  //   plural: 'Laboratori',
  //   singular: 'Laboratorio',
  //   pluralWA: 'I laboratori',
  //   singularWA: 'Il laboratorio',
  //   every: 'Tutti i laboratori',
  //   forurl: 'laboratori',
  //   ugly: 'Laboratorio',
  //   seofooterTitle: {
  //     vendita: {
  //       tag: 'h1',
  //     },
  //     affitto: {
  //       tag: 'h1',
  //     },
  //   },
  //   seofooterDesc: {
  //     vendita: {
  //       tag: 'h2',
  //       txt: 'I laboratori sono immobili di vitale importanza per molte attività. Questi sono spazi adibiti a diversi usi, da quelli industriali a quelli scientifici, per arrivare fino a quelli artistici. Sono infatti tante le possibilità che questi immobili offrono e non è raro vedere una conversione di questi in nuovi ambienti. Investire in questi spazi è sempre una buona idea. Come investimento personale, ma anche per chi possiede un’azienda, la quale potrà sul lungo periodo spalmare i costi sostenuti e dotarsi di un asset fondamentale. Su Casa.it trovi gli annunci di laboratori in vendita più rilevanti sul suolo italiano. Affina la tua ricerca grazie ai filtri disponibili e scopri il laboratorio in vendita che fa più al tuo caso.',
  //     },
  //     affitto: {
  //       tag: 'h2',
  //       txt: 'L’acquisto di un laboratorio può riservare sempre qualche sorpresa. Tra le spese da sostenere non ci sono solo quelle imputabili direttamente all’acquisto dello stesso. Basti pensare ad esempio a quelle da dover affrontare per la ristrutturazione del locale, che possono gravare in modo significativo sulla spesa preventivata. Ecco perché molti italiani preferiscono orientare la loro scelta verso un laboratorio in affitto. In centro città, in periferia, in campagna o a due passi dal mare. Gli annunci di laboratori in affitto su Casa.it sono davvero tantissimi! Utilizza le schede dettagliate per approfondire la tua ricerca, screma i risultati con i filtri a tua disposizione e scopri tutte le caratteristiche del tuo prossimo laboratorio.',
  //     },
  //   },
  // },
  'locale-commerciale': {
    ...SEOPagesLocaleCommerciale,
  },
  'locale+commerciale': {
    ...SEOPagesLocaleCommerciale,
  },
  'negozio+locale+commerciale': {
    ...SEOPagesLocaleCommerciale,
  },
  'negozio-locale-commerciale': {
    ...SEOPagesLocaleCommerciale,
  },
  // magazzino: {
  //   plural: 'Magazzini',
  //   singular: 'Magazzino',
  //   pluralWA: 'I magazzini',
  //   singularWA: 'Il magazzino',
  //   every: 'Tutti i magazzini',
  //   forurl: 'magazzini',
  //   ugly: 'Magazzino',
  //   seomenuitem: true,
  //   seofooterTitle: {
  //     vendita: {
  //       tag: 'h1',
  //     },
  //     affitto: {
  //       tag: 'h1',
  //     },
  //   },
  //   seofooterDesc: {
  //     vendita: {
  //       tag: 'h2',
  //       txt: 'Spesso l’acquisto di un magazzino è essenziale per iniziare un’attività commerciale. Trovare uno stabilimento che abbia tutte le caratteristiche in linea con le esigenze imprenditoriali può essere un processo lungo, faticoso e con un inutile dispendio di risorse. Casa.it ti aiuta a trovare la soluzione giusta per te tra migliaia di annunci in tutta Italia venendo incontro a qualsiasi tipo di esigenza che si può riscontrare durante la ricerca di un magazzino in vendita. Il magazzino è un’appendice della sede principale e in quanto tale si potrebbe avere l’esigenza di acquistare una struttura che si trovi nei pressi dell’attività; oppure, per ragioni logistiche, alcuni imprenditori optano per l’allestimento di un magazzino in punti strategici delle città. Casa.it ti aiuta ad ottenere informazioni decisive per soddisfare questo tipo di esigenze, fornendoti metratura, locali, posizione esatta e prezzo per tutti i magazzini in vendita sul portale.',
  //     },
  //     affitto: {
  //       tag: 'h2',
  //       txt: 'Il mondo del lavoro è in costante mutazione, diventando sempre più flessibile e dinamico. Proprio per questo aspetto, molte aziende ai giorni d’oggi preferiscono acquisire gli immobili tramite un contratto di affitto, piuttosto che assumersi un rischio maggiore con l’acquisto. Un magazzino in affitto può essere la soluzione ideale per aggiudicarsi una struttura di vitale importanza per l’attività commerciale, mantenendo una flessibilità e libertà contrattuale, tipica delle soluzioni in affitto. Quindi, se stai cercando un magazzino in affitto, Casa.it viene in tuo aiuto offrendoti la possibilità di comparare migliaia di annunci in tutta Italia e trovare l’annuncio che corrisponde alle tue esigenze imprenditoriali.',
  //     },
  //   },
  // },
  ristorante: {
    plural: 'Ristoranti',
    singular: 'Ristorante',
    pluralWA: 'I ristoranti',
    singularWA: 'Il ristorante',
    every: 'Tutti i ristoranti',
    forurl: 'ristoranti',
    ugly: 'Ristorante',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Se il tuo sogno è aprire un ristorante ma non riesci a trovare il locale in vendita che soddisfi le tue esigenze, Casa.it ha quello che fa per te! Filtra la tua ricerca tra migliaia di annunci di ristoranti in vendita e trova il locale che rispecchia al meglio le tue esigenze. Un ristorante già attrezzato consente di beneficiare della struttura già pronta per l’attività di ristorazione e di risparmiare su eventuali costi di ristrutturazione, molte volte necessari per rientrare nelle normative sanitarie e di sicurezza. Con Casa.it puoi avere accesso a migliaia di annunci di ristoranti in vendita. Grazie alle schede dedicate potrai avere tutte le informazioni di cui hai bisogno alla portata di un clic. Scopri la prossima casa della tua attività!',
      },
      affitto: {
        tag: 'h2',
        txt: 'Il mondo del lavoro non è più come quello di una volta e i nuovi imprenditori hanno bisogno di un ambiente di lavoro dinamico e in grado di cambiare in poco tempo. Per questo molte aziende scelgono gli immobili affidandosi ad un contratto di locazione. Se l’acquisto di un ristorante rappresenta un costo che non è alla portata di tutte le tasche, allora bisogna tenere in considerazione un ristorante in affitto. Il rischio aziendale si abbassa notevolmente lasciando spazio a maggiori risorse da poter investire all’interno dell’azienda. Casa.it viene incontro alle esigenze dell’azienda offrendo la possibilità di cercare tra migliaia di annunci di ristoranti in affitto presenti in tutta Italia.',
      },
    },
  },
  ufficio: {
    plural: 'Uffici',
    singular: 'Ufficio',
    pluralWA: 'Gli uffici',
    singularWA: 'L\'ufficio',
    every: 'Tutti gli uffici',
    forurl: 'uffici',
    ugly: 'Ufficio',
    seomenuitem: true,
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Tante attività, nei più disparati settori, non possono prescindere dall’avere uno spazio dedicato agli uffici. Centro nevralgico di tante realtà, l’ufficio è il motore di tantissime operazioni necessarie al successo delle attività produttive delle imprese; inoltre, spesso, viene destinato anche a funzioni di rappresentanza e quindi come strumento per comunicare l’affidabilità e la professionalità di un’azienda. Acquistare un ufficio è un ottimo investimento per garantirsi un asset dal valore estremamente significativo e il ritorno in termini non solo economici, ma anche di immagine, è garantito. Su Casa.it trovi tantissimi annunci di uffici in vendita. Scegli tra le offerte delle più grandi agenzie immobiliari italiane e trova la soluzione ideale per te e per la tua impresa.',
      },
      affitto: {
        tag: 'h2',
        txt: 'Un ufficio che funga da sede amministrativa e operativa o che sia destinato alla sola rappresentanza è molto importante per tutte le aziende che erogano servizi e prodotti. Per tutti gli imprenditori che preferiscono soluzioni più rapide e meno gravose dal punto di vista economico, è possibile considerare la possibilità relativa agli uffici in affitto. Su Casa.it trovi tante proposte facilmente consultabili attraverso il tuo smartphone o dal computer di casa tua. Tutti corredati da una scheda che evidenzia le caratteristiche dell’immobile, gli annunci di uffici in affitto sono facilmente consultabili. Per orientarti meglio nella tua ricerca, Casa.it mette a tua disposizione tanti filtri per affinare la tua ricerca e trovare gli uffici in affitto più adatti per le tue esigenze.',
      },
    },
  },
  terreni: {
    plural: 'Terreni',
    singular: 'Terreno',
    pluralWA: 'I terreni',
    singularWA: 'Il terreno',
    every: 'Tutti i terreni',
    forurl: 'terreni',
    publisherHpSlug: 'terreni',
    publisherHpText: 'terreni',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: SEOFooterTerreniBuyDesc,
      },
      affitto: {
        tag: 'h2',
        txt: SEOFooterTerreniRentDesc,
      },
    },
  },
  'terreno-agricolo': {
    ...SEOPagesTerrenoAgricolo,
  },
  'terreno+agricolo': {
    ...SEOPagesTerrenoAgricolo,
  },
  'terreno-edificabile': {
    ...SEOPagesTerrenoEdificabile,
  },
  'terreno+edificabile': {
    ...SEOPagesTerrenoEdificabile,
  },
  'terreno-industriale': {
    ...SEOPagesTerrenoIndustriale,
  },
  'terreno+industriale': {
    ...SEOPagesTerrenoIndustriale,
  },
  'garage+posti+auto': {
    ...SEOPagesGaragePostiAuto,
  },
  'garage-posti-auto': {
    ...SEOPagesGaragePostiAuto,
  },
  stanze: {
    plural: 'Stanze',
    singular: 'Stanza',
    pluralWA: 'Le stanze',
    singularWA: 'La stanza',
    every: 'Tutte le stanze',
    forurl: 'stanze',
    publisherHpSlug: 'stanze',
    publisherHpText: 'stanze',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: '',
      },
      affitto: {
        tag: 'h2',
        txt: 'Le stanze in affitto sono sempre molto richieste in particolare da studenti fuori sede o da lavoratori lontani da casa e, più in generale, da tutti coloro i quali preferiscono dividere le spese domestiche e non hanno problemi a condividere gli spazi della casa. Casa.it ti aiuta a trovare la stanza che fa per te, tra migliaia di annunci in tutta Italia offerti dalle più affidabili agenzie italiane. Ottieni facilmente tutte le informazioni che stai cercando grazie alle schede consultabili da smartphone, PC e tablet, corredate da foto e da tutte le informazioni di cui hai bisogno. Sul nostro sito troverai tutti i dettagli che ti servono per scegliere la tua prossima stanza in affitto. Grazie ai filtri potrai affinare i risultati di ricerca, scremando per prezzo, servizi disponibili e prossimità con i mezzi pubblici. Casa.it ti offre questo e tanto altro, valuta la migliore offerta sul mercato e trova la stanza in affitto in linea con le tue esigenze.',
      },
    },
  },
  'nuove-costruzioni': {
    plural: 'Nuove costruzioni',
    singular: 'Nuova costruzione',
    pluralWA: 'Le nuove costruzioni',
    singularWA: 'La nuova costruzione',
    every: 'Tutte le nuove costruzioni',
    forurl: 'nuove-costruzioni',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Scegliere di acquistare una casa è un passo molto importante, sia per la spesa da dover mettere a bilancio, sia per tutto quello che ne può conseguire: è innegabile che la ristrutturazione dell’immobile stesso sia un’attività che può risultare particolarmente stressante. Ecco perché gli annunci di nuove costruzioni in vendita sono sempre ricercati, non solo dalle giovani coppie ma anche dalle famiglie, che non vogliono rinunciare alle comodità tipiche delle nuove palazzine. Spesso situate appena al di fuori dei contesti urbani, ma anche all’interno delle città stesse, le nuove costruzioni in vendita possono garantire, a fronte di un costo proporzionalmente inferiore, soluzioni molto convenienti in termini di dimensioni ma non solo: sono tante infatti le possibilità che prevedono box auto o un giardino condominiale. Scopri la soluzione ideale per te grazie a Casa.it!',
      },
      affitto: {
        tag: 'h2',
        txt: 'Dai centri cittadini alle nuove periferie, è innegabile che in qualunque zona si cerchi casa è importante che questa sia in buono stato. Questo è particolarmente vero per chi cerca casa in affitto, dato che difficilmente il locatario vorrà sobbarcarsi eventuali spese per la ristrutturazione dell’immobile. La soluzione migliore diventa quella relativa alle nuove costruzioni in affitto. Spesso a poca distanza da snodi cruciali delle città, queste palazzine vengono preferite per diversi fattori: garantiscono box auto, efficienza energetica e una distribuzione degli spazi abitativi ottimali. Su Casa.it hai la possibilità di trovare gli annunci delle più affidabili agenzie immobiliari per le nuove costruzioni in affitto e scegliere in modo facile e veloce la tua prossima casa.',
      },
    },
  },
  vacanza: {
    plural: 'Vacanze',
    singular: 'Vacanza',
    pluralWA: 'Case vacanza',
    singularWA: 'Casa vacanza',
    every: 'Tutte le case vacanza',
    forurl: 'vacanze',
    publisherHpSlug: 'vacanze',
    publisherHpText: 'vacanze',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: '',
      },
      affitto: {
        tag: 'h2',
        txt: '',
      },
    },
  },
  vacanze: {
    plural: 'Case in affitto breve',
    singular: 'Case in affitto breve',
    pluralWA: 'Le Case in affitto breve',
    singularWA: 'La Casa in affitto breve',
    every: 'Tutte le case in affitto breve',
    forurl: 'vacanze',
    publisherHpSlug: 'vacanze',
    publisherHpText: 'vacanze',
    seofooterTitle: {
      vendita: {
        tag: 'h1',
      },
      affitto: {
        tag: 'h1',
      },
    },
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: '',
      },
      affitto: {
        tag: 'h2',
        txt: '',
      },
    },
  },
  uffici: {
    plural: 'Uffici',
    singular: 'Ufficio',
    pluralWA: 'Gli uffici',
    singularWA: 'L\'ufficio',
    every: 'Tutti gli uffici',
    forurl: 'uffici',
    publisherHpSlug: 'uffici',
    publisherHpText: 'uffici',
  },
  capannoni: {
    plural: 'Capannoni',
    singular: 'Capannone',
    pluralWA: 'I capannoni',
    singularWA: 'Il capannone',
    every: 'Tutti i capannoni',
    forurl: 'capannoni',
    publisherHpSlug: 'capannoni',
    publisherHpText: 'capannoni',
  },
  'edifici-palazzi': {
    plural: 'Edifici, stabili e palazzi',
    singular: 'Edifici, stabili o palazzi',
    pluralWA: 'Gli edifici, gli stabili e i palazzi',
    singularWA: 'L\'edificio, lo stabile o il palazzo',
    every: 'Tutti gli edifici, gli stabili e i palazzi',
    forurl: 'edifici-palazzi',
    publisherHpSlug: 'edifici-palazzi',
    publisherHpText: 'edifici/palazzi',
    seofooterDesc: {
      vendita: {
        tag: 'h2',
        txt: 'Acquistare un\'intero stabile per poterlo ristrutturare, rivenderlo o affittarlo, un\'idea che sempre più imprenditori (ma anche semplici privati) stanno prendendo in considerazione. Grazie all\'aumento del settore immobiliare, tale soluzione può essere molto vantaggiosa, soprattutto se il prezzo di acquisto del Palazzo è contenuto. I palazzi più richiesti, forse è inutile dirlo, sono quelli nei centri storici, stabili che hanno molta appetibilità e buon mercato, ma negli ultimi anni anche semplici palazzi in zone periferiche stanno riscuotendo molto successo, soprattutto se si tratta di immobili da adibire a uffici e co-working. Ultimo modello di investimento, sempre più richiesto, è quello legato ai palazzi residenziali, con imprenditori e privati che acquistano l\'intera palazzina per poi frazionarla in appartamenti da vendere, o da affittare, singolarmente. Molto apprezzato anche il cambio di destinazione di alcuni locali, favorito dalla semplicità con cui è ora possibile fare questo passaggio: acquistare un palazzo di uffici e trasformarlo in appartamenti (o viceversa), può essere un\'investimento molto redditizio.',
      },
      affitto: {
        tag: 'h2',
        txt: 'Dai centri cittadini alle nuove periferie, è innegabile che in qualunque zona si cerchi casa è importante che questa sia in buono stato. Questo è particolarmente vero per chi cerca casa in affitto, dato che difficilmente il locatario vorrà sobbarcarsi eventuali spese per la ristrutturazione dell’immobile. La soluzione migliore diventa quella relativa alle nuove costruzioni in affitto. Spesso a poca distanza da snodi cruciali delle città, queste palazzine vengono preferite per diversi fattori: garantiscono box auto, efficienza energetica e una distribuzione degli spazi abitativi ottimali. Su Casa.it hai la possibilità di trovare gli annunci delle più affidabili agenzie immobiliari per le nuove costruzioni in affitto e scegliere in modo facile e veloce la tua prossima casa.',
      },
    },
  },
};

export const hubLicenseTypeGroupsAnchors = {
  'attivita-licenza-commerciale': [
    'struttura-ricettiva',
    'bar-pub-caffe',
    'ristorazione',
    'alimentari',
    'tabaccheria',
    'farmacia',
    'edicola',
    'commercio-al-dettaglio',
    'estetica-e-bellezza',
    'palestre',
    'servizi-professionali',
    'negozio',
  ],
  'negozio-locale-commerciale': [
    'laboratorio',
    'magazzino',
  ],
};

export default SEOPagesPtypes;
